"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _R2 = /*#__PURE__*/ _interop_require_default(require("./R2"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let R2Plugin = class R2Plugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return R2Plugin.storageAdapter;
    }
    async init(config) {
        R2Plugin.storageAdapter = new _R2.default(config);
        await R2Plugin.storageAdapter.init();
    }
};
const _default = R2Plugin;
